import { render } from "./FoodList.vue?vue&type=template&id=62bb2a1a&scoped=true"
import script from "./FoodList.vue?vue&type=script&lang=js"
export * from "./FoodList.vue?vue&type=script&lang=js"

import "./FoodList.vue?vue&type=style&index=0&id=62bb2a1a&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62bb2a1a"]])

export default __exports__